import '@/polyfills';
import Vue from 'vue';
import vTooltip from 'v-tooltip';
import VueSignaturePad from 'vue-signature-pad';
import Vuetify from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';
import { apolloProvider } from '@signing-page/apollo';
import App from '@signing-page/App.vue';
import router from '@signing-page/router';
import store from '@signing-page/store/store';
import i18n from '@/lang';
import './init';
import gaClickOutside from '@/directives/ga-click-outside';
import '@/bugsnag';
import 'focus-visible';

// Globally register all `_base`-prefixed components
import '@components/_globals';

Vue.config.productionTip = false;
Vue.use(gaClickOutside);
Vue.use(vTooltip);
Vue.use(VueSignaturePad);
Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
});

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: h => h(App),
}).$mount('#signing-page');
